import React from 'react';
import CabCrudPage from './CabCrudPage';
import { uploadAdminImage } from '../../../api/cabsAdmin';

const AdminCabsVehicleCategories = () => (
  <CabCrudPage
    title="Vehicle Categories"
    description="Configure cab classes, visibility, and defaults."
    resource="vehicle-categories"
    defaultItem={{
      name: '',
      slug: '',
      imageUrl: '',
      description: '',
      sortOrder: 0,
      isOutstationSupported: true,
      isActive: true,
    }}
    columns={[
      { key: 'name', label: 'Name' },
      { key: 'slug', label: 'Slug' },
      {
        key: 'imageUrl',
        label: 'Image',
        render: (row) =>
          row.imageUrl ? (
            <img
              src={row.imageUrl}
              alt={row.name}
              style={{ width: 56, height: 40, objectFit: 'cover', borderRadius: 10 }}
            />
          ) : (
            '—'
          ),
      },
      { key: 'sortOrder', label: 'Sort' },
    ]}
    fields={[
      { name: 'name', label: 'Name', required: true },
      { name: 'slug', label: 'Slug', required: true },
      { name: 'imageUrl', label: 'Category image', type: 'image', col: 'col-12' },
      { name: 'description', label: 'Description', type: 'textarea', col: 'col-12' },
      { name: 'sortOrder', label: 'Sort order', type: 'number' },
      { name: 'isOutstationSupported', label: 'Outstation supported', type: 'checkbox', col: 'col-md-6' },
      { name: 'isActive', label: 'Active', type: 'checkbox', col: 'col-md-6' },
    ]}
    uploadHandler={uploadAdminImage}
  />
);

export default AdminCabsVehicleCategories;
